<template>
    <el-dialog
        v-if="action"
        :title="action.previewbox.title"
        :visible.sync="show"
        width="30%">
        
        <!-- Titulo -->
        <!--<p v-if="action.previewbox.title">{{action.previewbox.title}}</p>-->

        <!-- Input -->
        <template v-if="action.previewbox.input">
            <el-input :type="action.previewbox.input" placeholder="Buscar..." v-model="value"></el-input>
        </template>

        <!-- botones -->
        <span slot="footer" class="dialog-footer">
            <el-button v-if="[1,2].includes(action.previewbox.button)"  type="primary" @click="go(1)">Si</el-button>
            <el-button v-if="action.previewbox.button === 2" @click="go(2)">No</el-button>
            <el-button v-if="action.previewbox.button === 3" @click="go(3)">Cancelar</el-button>
        </span>
    </el-dialog>
</template>

<script>
	export default {
		name: 'Alert',
		props: ['currentAction'],
		data () {
			return {
                show: false,
                action: null,
                input: null,
                value: '',
                loading: false
            }
        },
        watch: {
            currentAction() {
                if (typeof this.currentAction !== 'object') return
                this.init()
            }
        },
        methods: {
            init() {

                this.action = this.currentAction.action
                this.input = this.currentAction.input

                // Comprobar si la accion tiene previewBox
                if (this.action.hasOwnProperty('previewbox')) {

                    this.show = true // Abrir modal

                } else {
                    this.$emit('next')
                }
            },
            async go(value) {
                
                // Verificar url para boton presionado
                let url_exist = Object.keys(this.action.previewbox).find(f => f === `url_${value}`)
                if(url_exist) {
                    
                    let url = this.action.previewbox[url_exist]

                    // Comprobar si la accion tiene dispone de input para enviar
                    try {
                        
                        let resp = null
                        if (this.action.previewbox.input) {

                            // Hacer llamada a la url ## PENDIENTE CONFIRMAR COMO MANDARLO
                            resp = await (await fetch(url, {
                                method: 'GET'
                            })).json()

                        } else {

                            resp = await (await fetch(url, {
                                method: 'GET'
                            })).json()
                        }
                        
                        if (resp) { // Verificar respuesta
                            this.$emit('next') // Verificacion correcta -> continua
                        } else {
                            this.$emit('next', resp['data']) // Continua con informacion
                        }

                    } catch (err) {
                        console.log(err)
                    }
                    
                } else if (value == 1) {
                    this.$emit('next') // no hay url y continua directamente
                } else {
                    this.$emit('cancel')
                }

                this.show = false
            }
        }
	}
</script>

<style lang="scss">
</style>